export default {
    ERRO_401: 'Sua sessão expirou. Você será redirecionado para o login...',
    ERRO_403: 'Usuário não tem permissão para realizar ações no sistema. Por favor entre em contato com o suporte.',
    ERRO_DEFAULT: 'Ocorreu um erro ao realizar a operação.',
    ERRO_SEM_CONEXAO_INTERNET: 'Verifique a conexão com a internet.',
    ERRO_PERDA_SESSAO: 'Desculpe, você perdeu a sessão e sua página será recarregada.',
    SUCESSO_DEFAULT: 'Operação realizada com sucesso.'
}
